// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__2STwp","root_primary":"Button_root_primary__2BhKd","rootPrimary":"Button_root_primary__2BhKd"};
    if(module.hot) {
      // 1586964020917
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  